import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function notUniqueValidator(value: string | undefined): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (value == control.value) {
      return { notUnique: true };
    }
    return null;
  };
}
